export default {
    MOBILE_WIDTH: 1244
}


// WEBPACK FOOTER //
// ./store/index.js